module.exports = __webpack_public_path__ + "static/img/1688.e3367a8b.png";